import script from "./AttachmentUploaderPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentUploaderPopup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__